"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highlightText = exports.getTextToHighlight = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/regeneratorRuntime"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var getSearchWordsWithIndex = function getSearchWordsWithIndex(searchText) {
  return searchText.toLowerCase().split(' ').filter(function (word) {
    return word;
  }).map(function (word, index) {
    return {
      word: word,
      index: index
    };
  });
};

var getSpanText = function getSpanText(spanElement) {
  if (!spanElement) {
    return '';
  }

  return spanElement.textContent.toLowerCase();
};

var qualifyWordMatch = function qualifyWordMatch(searchWord, sequence) {
  var THRESHOLD = 0.8;
  var searchWordLength = searchWord.length;
  var sequenceLength = sequence.length;

  if (sequenceLength === 0) {
    return {
      isMatch: false,
      matchScore: 0
    };
  }

  var matchScore = sequenceLength / searchWordLength;
  return {
    isMatch: matchScore >= THRESHOLD,
    matchScore: matchScore
  };
};

var getStartEnd = function getStartEnd(str, sub) {
  if (!sub) {
    return {
      start: -1,
      end: -1
    };
  }

  var start = str.indexOf(sub[0]); // Find the first character match

  if (start === -1) return {
    start: -1,
    end: -1
  };
  var matchLength = 0; // Compare characters one by one until mismatch or end of either string

  while (matchLength < sub.length && matchLength < str.length && str[start + matchLength] === sub[matchLength]) {
    matchLength++;
  }

  return {
    start: start,
    end: start + matchLength
  };
};

var getPossibleMatchesByWord = function getPossibleMatchesByWord(spanElements, searchWord) {
  var matches = [];
  var searchState = searchWord;
  var sequence = '';
  var spanToCharIdx = {}; // Try all matches within spans

  var _iterator = (0, _createForOfIteratorHelper2.default)(spanElements.entries()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
          spanIdx = _step$value[0],
          spanElement = _step$value[1];

      var spanText = getSpanText(spanElement);
      var spanTextWords = spanText.split(' ');
      var currentPosition = 0; // Track position in the entire spanText

      var _iterator2 = (0, _createForOfIteratorHelper2.default)(spanTextWords.entries()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = (0, _slicedToArray2.default)(_step2.value, 2),
              spanWordIdx = _step2$value[0],
              spanWord = _step2$value[1];

          if (sequence.length === 1) {
            // Reset state
            searchState = searchWord;
            sequence = '';
            spanToCharIdx = {};
          }

          var _getStartEnd = getStartEnd(spanWord, searchState),
              start = _getStartEnd.start,
              end = _getStartEnd.end;

          if (start !== 0) {
            var _getStartEnd2 = getStartEnd(spanWord, searchWord),
                fullWordStart = _getStartEnd2.start,
                fullWordEnd = _getStartEnd2.end;

            if (fullWordStart === 0) {
              searchState = searchWord;
              sequence = '';
              spanToCharIdx = {};
              start = fullWordStart;
              end = fullWordEnd;
            }
          }

          if (start === 0) {
            var matchText = spanWord.slice(start, end);
            searchState = searchState.slice(end);
            sequence += matchText; // Use currentPosition to calculate the actual start/end in the spanText

            var spanStart = currentPosition + start;
            var spanEnd = currentPosition + end;
            spanToCharIdx[spanIdx] = {
              start: spanStart,
              end: spanEnd,
              matchText: matchText
            };

            var _qualifyWordMatch = qualifyWordMatch(searchWord, sequence),
                isMatch = _qualifyWordMatch.isMatch,
                matchScore = _qualifyWordMatch.matchScore;

            if (isMatch) {
              matches.push({
                matchText: sequence,
                location: spanToCharIdx,
                matchScore: matchScore
              }); // Reset state

              searchState = searchWord;
              sequence = '';
              spanToCharIdx = {};
            }
          }

          var isLastWord = spanWordIdx === spanTextWords.length - 1; // Update currentPosition to include the word length and space

          currentPosition += spanWord.length;

          if (!isLastWord) {
            currentPosition += 1; // Add 1 for the space between words
            // Reset state

            searchState = searchWord;
            sequence = '';
            spanToCharIdx = {};
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return matches;
};

var getPossibleMatches = function getPossibleMatches(spanElements, searchWords) {
  var matchesByWordIdx = {};

  var _iterator3 = (0, _createForOfIteratorHelper2.default)(searchWords),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _step3.value,
          word = _step3$value.word,
          index = _step3$value.index;
      matchesByWordIdx[index] = {
        word: word,
        matches: getPossibleMatchesByWord(spanElements, word)
      };
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return matchesByWordIdx;
};

var getMatchDistance = function getMatchDistance(match1, match2, expectedOrder) {
  var span1 = Number(Object.keys(match1.location)[0]);
  var span2 = Number(Object.keys(match2.location)[0]);
  var distance;

  if (span1 === span2) {
    var pos1 = match1.location[span1].end;
    var pos2 = match2.location[span2].start;
    distance = Math.abs(pos2 - pos1);
  } else {
    distance = Math.abs(span2 - span1) * 100;
  } // Much larger penalty for wrong order relative to search text


  if (expectedOrder === 'after' && span2 < span1 || expectedOrder === 'after' && span1 === span2 && match2.location[span2].start < match1.location[span1].end) {
    distance += 1000000; // Much larger penalty for wrong order
  }

  return distance;
};

var findClosestMatch = function findClosestMatch(searchWordsWithIndex, matchesBySequence) {
  var searchWordIndexes = searchWordsWithIndex.map(function (word) {
    return word.index;
  }).filter(function (i) {
    return i !== 0;
  });
  var firstWordMatches = matchesBySequence[0].matches;
  var bestSequence = null;
  var bestScore = Infinity;

  var _iterator4 = (0, _createForOfIteratorHelper2.default)(firstWordMatches),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var firstMatch = _step4.value;
      var currentSequence = [firstMatch];
      var lastMatch = firstMatch;
      var currentScore = 0;

      var _iterator5 = (0, _createForOfIteratorHelper2.default)(searchWordIndexes),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var wordIndex = _step5.value;
          var wordMatches = matchesBySequence[wordIndex].matches;
          var bestNextMatch = null;
          var bestDistance = Infinity;

          var _iterator6 = (0, _createForOfIteratorHelper2.default)(wordMatches),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var match = _step6.value;
              var distance = getMatchDistance(lastMatch, match, 'after');

              if (distance < bestDistance) {
                bestDistance = distance;
                bestNextMatch = match;
              }
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          if (bestNextMatch) {
            currentScore += bestDistance; // Add the distance to the current sequence score

            currentSequence.push(bestNextMatch);
            lastMatch = bestNextMatch;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      if (currentScore < bestScore) {
        // Compare current sequence score with best score
        bestScore = currentScore;
        bestSequence = currentSequence;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return bestSequence || [];
};

var getHighlightPositions = function getHighlightPositions(closestMatch) {
  var highlightPositionsBySpanIdx = {};

  var _iterator7 = (0, _createForOfIteratorHelper2.default)(closestMatch),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var match = _step7.value;

      for (var _i = 0, _Object$keys = Object.keys(match.location); _i < _Object$keys.length; _i++) {
        var spanIdx = _Object$keys[_i];
        var start = match.location[spanIdx].start;
        var end = match.location[spanIdx].end;

        if (!highlightPositionsBySpanIdx[spanIdx]) {
          highlightPositionsBySpanIdx[spanIdx] = {
            start: start,
            end: end
          };
        }

        if (highlightPositionsBySpanIdx[spanIdx]['start'] > start) {
          highlightPositionsBySpanIdx[spanIdx]['start'] = start;
        }

        if (highlightPositionsBySpanIdx[spanIdx]['end'] < end) {
          highlightPositionsBySpanIdx[spanIdx]['end'] = end;
        }
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return highlightPositionsBySpanIdx;
}; // MAIN


var getTextToHighlight = function getTextToHighlight(spanElements, searchText, pageRef) {
  var SPAN_TEXT_Y_POSITION_SPREAD_THRESHOLD = 9;

  try {
    var searchWords = getSearchWordsWithIndex(searchText); // Now store matches by sequence position instead of by word

    var possibleMatches = getPossibleMatches(spanElements, searchWords);
    console.log('[getTextToHighlight] possibleMatches: ', possibleMatches);
    var closestMatch = findClosestMatch(searchWords, possibleMatches);
    console.log('[getTextToHighlight] closestMatch: ', closestMatch);
    var highlightPositionsBySpanIdx = getHighlightPositions(closestMatch);
    var pageHeight = (pageRef === null || pageRef === void 0 ? void 0 : pageRef.offsetHeight) || Number.MAX_SAFE_INTEGER;
    var previousTop = -1;

    for (var _i2 = 0, _Object$keys2 = Object.keys(highlightPositionsBySpanIdx); _i2 < _Object$keys2.length; _i2++) {
      var spanIdx = _Object$keys2[_i2];
      var spanElement = spanElements[spanIdx];
      if (!spanElement.style) continue;
      var top = spanElement.offsetTop / pageHeight * 100;
      if (isNaN(top) || top < 0) continue;

      if (previousTop >= 0 && top > previousTop && top - previousTop > SPAN_TEXT_Y_POSITION_SPREAD_THRESHOLD) {
        // If the top position difference is greater than 9% of the page, likely highlighter hallucinated.
        // In that case, return empty result to let fuzzy highlighter try to do a better job.
        console.log("[getTextToHighlight] Detected likely hallucination with top position difference of ".concat(top - previousTop, "%."));
        return {};
      }

      previousTop = Math.max(previousTop, top + spanElement.offsetHeight / pageHeight * 100);
    }

    return highlightPositionsBySpanIdx;
  } catch (error) {
    console.error('[getTextToHighlight] error: ', error);
    return {};
  }
};

exports.getTextToHighlight = getTextToHighlight;

var highlightText = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(spanElements) {
    var _Object$keys3;

    var textToHighlight,
        _i3,
        _Object$keys4,
        spanIdx,
        spanElement,
        _textToHighlight$span,
        start,
        end,
        result,
        _args = arguments;

    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            textToHighlight = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

            if ((_Object$keys3 = Object.keys(textToHighlight)) !== null && _Object$keys3 !== void 0 && _Object$keys3.length) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            for (_i3 = 0, _Object$keys4 = Object.keys(textToHighlight); _i3 < _Object$keys4.length; _i3++) {
              spanIdx = _Object$keys4[_i3];
              spanElement = spanElements[spanIdx];
              _textToHighlight$span = textToHighlight[spanIdx], start = _textToHighlight$span.start, end = _textToHighlight$span.end; // add <mark> to the first and </mark> to the last character of the span element

              result = spanElement.textContent.slice(0, start) + "<mark>".concat(spanElement.textContent.slice(start, end), "</mark>") + spanElement.textContent.slice(end);
              spanElement.innerHTML = result;
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function highlightText(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.highlightText = highlightText;